import request from '@/utils/request';

//分页查询活动数据列表
export function getActivityManageList(values) {
  return request('/activityReport/queryActivityDataPage', {
    method: 'POST',
    data: values,
  });
}
